'use client';
import React, { FC, useState } from 'react';
import FsLightbox from 'fslightbox-react';
import { generateDirectusSrc } from '@/helpers/image';

interface LightBoxProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  media: any;
  clicked: number;
}

interface Item {
  layout_asset_translations_id: {
    id: string;
    type: string;
    item: {
      id: string;
      title: string;
    };
    colspan: number;
    rowspan: number;
  };
}

const FsLightBox: FC<LightBoxProps> = ({ show, setShow, media, clicked }) => {
  const [productIndex, setProductIndex] = useState(0);

  const filteredMedia = media?.filter(
    (item: Item) => item?.layout_asset_translations_id?.type !== 'video'
  );

  const sources = filteredMedia?.map((item: Item) =>
    generateDirectusSrc(item?.layout_asset_translations_id?.item?.id, 1200)
  );

  const types = filteredMedia?.map(() => null);

  return (
    <>
      <FsLightbox
        toggler={show}
        sources={sources}
        types={types}
        slide={clicked + 1}
        key={productIndex}
        loadOnlyCurrentSource={true}
        onClose={() => {
          setShow(false);
          setProductIndex(productIndex + 1);
        }}
      />
    </>
  );
};

export default FsLightBox;
